import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import AOS from 'aos';

import 'aos/dist/aos.css';

const Container = styled.section`
	/* IE styles */
	display: flex;
	flex-wrap: wrap;
	flex-direction: ${props => (props.colReverse ? 'row' : 'row-reverse')};
	align-items: center;
	padding-left: 10vw;
	padding-right: 10vw;
	background: ${props =>
		!props.bgSrc
			? 'none'
			: 'url(' +
			  props.bgSrc +
			  '), linear-gradient(to right bottom, #ff9b3c, #b352be 50%, #2bc5d0)'};
	background-position-y: ${props => (props.colReverse ? 'bottom' : 'top')};
	background-repeat: no-repeat;
	background-size: contain;
	margin: 10vmin 0;
	/* end IE styles */

	@supports (display: grid) {
		direction: ${props => (props.colReverse ? 'rtl' : 'ltr')};
		display: grid;
		padding-left: 0;
		padding-right: 0;
		margin: 0;
		background: none;
		grid-template-columns: repeat(2, 50vw);
		grid-template-rows: 1fr 3fr 1fr;
		grid-template-areas:
			'visual .'
			'visual text'
			'visual .';
	}

	@media screen and (max-width: ${props => props.theme.mobileBreakPoint}) {
		grid-template-columns: 100vw;
		grid-template-rows: repeat(2, 1fr);
		margin-bottom: 10vh;
		grid-template-areas: ${props =>
		props.rowReverse
			? `'text'
			   'visual'`
			: `'visual'
			   'text'`};
	}
`;

const Visal = styled.div`
	/* IE styles */
	display: flex;
	height: 100%;
	width: 50%;
	/* end IE styles */

	@supports (display: grid) {
		grid-area: visual;
		width: 100%;
	}

	align-items: center;
	justify-content: center;

	> * {
		max-width: 80%;
		max-height: 50vmin;

		@media screen and (max-width: ${props => props.theme.mobileBreakPoint}) {
			max-width: 100%;
			max-height: 90vmin;
		}
	}
`;

const Text = styled.div`
	padding-top: ${props => (props.noBg ? '10%' : 'calc(10vw / 2)')};
	padding-bottom: ${props => (props.noBg ? '10%' : 'calc(10vw / 2)')};
	padding-top: ${props =>
		!props.bgSrc ? '10%' : 'calc(var(--side-margin) / 2)'};
	padding-bottom: ${props =>
		props.noBg ? '10%' : 'calc(var(--side-margin) / 2)'};
	color: ${props => (props.noBg ? 'inherit' : 'black')};
	text-align: left;
	direction: ltr;
	font-size: var(--fs-medium);

	width: 50%;

	@supports (display: grid) {
		grid-area: text;
		width: calc(100% - 10vw);
		width: calc(100% - var(--side-margin));
	}

	h2 {
		margin-bottom: 20px;
		color: #FF9C46;
		color: var('--orange');
		font-size: var(--fs-big);
	}

	@media screen and (max-width: ${props => props.theme.mobileBreakPoint}) {
		text-align: center;
		width: 100%;
		padding: 20vw 10vw;
		padding: calc(2 * var(--side-margin)) var(--side-margin);
	}
`;

const BgImg = styled.div`
	grid-column: 1 / -1;
	grid-row: ${props => (props.rowReverse ? '2 / -1' : '1 / -2')};
	background-image: url(${props => props.src}), var(--primary-gradient);
	background-size: contain;
	background-position-y: ${props => (props.colReverse ? 'bottom' : 'top')};
	background-repeat: no-repeat;
	z-index: -1;
	height: 100%;

	@media screen and (max-width: 600px) {
		background-size: 200%;
		height: 90%;
		align-self: ${props => (props.rowReverse ? 'start' : 'end')};
		grid-row: 1 / -1;
	}
`;

class Section extends PureComponent {
	componentDidMount() {
		AOS.init();
		AOS.refresh();
	}

	componentDidUpdate() {
		AOS.refresh();
	}
	render() {
		const {
			header,
			text,
			bgimg,
			colReverse,
			rowReverse,
			children
		} = this.props;

		return (
			<Container colReverse={colReverse} rowReverse={rowReverse} bgSrc={bgimg}>
				<Text
					colReverse={colReverse}
					noBg={!bgimg}
					data-aos="fade-right"
					data-aos-easing="ease-in-sine"
				>
					<h2>{header}</h2>
					{text}
				</Text>
				{children && <Visal colReverse={colReverse}>{children}</Visal>}
				{bgimg && (
					<BgImg src={bgimg} rowReverse={colReverse} colReverse={colReverse} />
				)}
			</Container>
		);
	}
}

Section.propTypes = {
	header: PropTypes.string.isRequired,
	text: PropTypes.string,
	bgimg: PropTypes.string,
	colReverse: PropTypes.bool,
	rowReverse: PropTypes.bool,
	children: PropTypes.node
};

export default Section;



// WEBPACK FOOTER //
// ./src/components/Section.js